export enum actionTypes {
  CURRICULUM_SELECTA_FETCH = 'CURRICULUM_SELECTA_FETCH',
  CURRICULUM_SELECTA_SUCCESS = 'CURRICULUM_SELECTA_SUCCESS',
  CURRICULUM_SELECTA_ERROR = 'CURRICULUM_SELECTA_ERROR',
  CURRICULUM_SELECTA_RESET = 'CURRICULUM_SELECTA_RESET',
}

export enum CurriculumSelectaStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface CurriculumSelecta {
  id: number
  nombre: string
}

export interface CurriculumSelectaState {
  curriculumSelectaStatus: CurriculumSelectaStatus
  curriculumSelecta?: CurriculumSelecta
}

export interface CurriculumSelectaFetch {
  type: typeof actionTypes.CURRICULUM_SELECTA_FETCH
  payload: null
}

export interface CurriculumSelectaSuccess {
  type: typeof actionTypes.CURRICULUM_SELECTA_SUCCESS
  payload: CurriculumSelecta
}

export interface CurriculumSelectaError {
  type: typeof actionTypes.CURRICULUM_SELECTA_ERROR
  payload: null
}

export interface CurriculumSelectaReset {
  type: typeof actionTypes.CURRICULUM_SELECTA_RESET
  payload: null
}

export type CurriculumSelectaActions =
  | CurriculumSelectaFetch
  | CurriculumSelectaSuccess
  | CurriculumSelectaError
  | CurriculumSelectaReset

export const initialState: CurriculumSelectaState = {
  curriculumSelectaStatus: CurriculumSelectaStatus.Idle,
}
